import * as React from "react";
import { BackOutter } from "../../../styles/Racelive";
import { handleRealTimeValue } from "../../../util";
interface IProps {
  totalBird: number;
  nowCount: number;
  totalPage: number;
  fly: string | null;
  speed: string | null;
  type: boolean;
  clockStop: string;
  clockStart: string;
}

// cannot think of a more descriptive name
// as BackOutter1 and BackOutter2 appeared to be
// copy pasted without much change
const BackOutter1 = ({
  totalBird,
  nowCount,
  totalPage,
  fly,
  speed,
  type,
  clockStop,
  clockStart,
}: IProps) => {
  return (
    <BackOutter isMatch={type}>
      <div className="colOne">
        <div className="flexCol">
          <div className="num first">
            {totalPage}
            <div className="totalPigeon">/ {totalBird}</div>
          </div>
          <div className="text" style={{ color: "white" }}>
            归巢羽数 / 集鸽羽数
          </div>
        </div>
      </div>
      <div className="colTwo">
        <div className="flexCol">
          <div className="num">
            {totalPage === 0 ? 0 : ((nowCount / totalBird) * 100).toFixed(2)}%
          </div>
          <div className="text">归巢率</div>
        </div>
        <div className="flexCol">
          <div className="num">
            {handleRealTimeValue(fly, clockStop, clockStart)}
          </div>
          <div className="text">参考飞行(分)</div>
        </div>
        <div className="flexCol">
          <div className="num">
            {handleRealTimeValue(speed, clockStop, clockStart)}
          </div>
          <div className="text">参考分数(米/分)</div>
        </div>
      </div>
    </BackOutter>
  );
};

export default BackOutter1;
